import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { db } from '../../../../firebase';
import { collection, onSnapshot } from 'firebase/firestore';
import { authorisedRolesLoadedAction } from '../../../actions/preloaded';
import { dataCompletedAction } from '../../../actions/store';

const useAuthorisedRolesLoader = () => {
  const [options, setOptions] = useState({ execute: false });

  const dispatch = useDispatch();

  const load = () => {
    dispatch(
      dataCompletedAction({ slice: 'Preloaded', path: 'authorisedRoles' })
    );
    return onSnapshot(
      collection(db, 'authorised_roles'),
      querySnapshot => {
        const items = [];

        querySnapshot.forEach(doc => {
          const dataItem = doc.data();
          dataItem.id = doc.id;
          items.push(dataItem);
        });

        dispatch(authorisedRolesLoadedAction(items));
      },
      error => {
        console.error('useAuthorisedRolesLoader.onSnapshot', error);
      }
    );
  };

  useEffect(() => {
    let unSub = () => {};
    if (options.execute) {
      unSub = load();
    }
    return () => {
      unSub();
    };
  }, [options]);

  return {
    loadAuthorisedRoles: (options = {}) => {
      setOptions({ ...options, execute: true });
    }
  };
};

export default useAuthorisedRolesLoader;
